import { render, staticRenderFns } from "./e-empty-placeholder.vue?vue&type=template&id=10e57ee1&scoped=true&"
import script from "./e-empty-placeholder.vue?vue&type=script&lang=js&"
export * from "./e-empty-placeholder.vue?vue&type=script&lang=js&"
import style0 from "./e-empty-placeholder.vue?vue&type=style&index=0&id=10e57ee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e57ee1",
  null
  
)

export default component.exports